import React from "react";
import { Backdrop, CircularProgress, makeStyles, Theme } from "@material-ui/core";

type Props = {
  open: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
}));

export function Loader({ open }: Props): React.ReactElement {
  const classes = useStyles();

  return (
    <>
      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
